/**
 * 全站共用 Minibar：页面上只挂载一个 DOM。
 * 各弹窗通过 register 接入；展示内容与点击行为取「最近打开」且仍有资格的弹窗。
 */
(function (global) {
  if (global.DLPopMiniBar && global.DLPopMiniBar.__shared) return;

  const EXPANDED_DURATION = 6000;
  const SHOW_SCROLL_DISTANCE = 80;
  const COLLAPSE_SCROLL_DISTANCE = 90;
  const COLLAPSE_MEDIA_QUERY = '(max-width: 990px)';
  const CONTENT_ROTATE_INTERVAL = 3000;
  const CONTENT_TRANSITION_DURATION = 400;
  const sources = new Map();
  let root = null;
  let contentEl = null;
  let labelItems = [];
  let labelSizer = null;
  let activeId = '';
  let activeContents = [];
  let activeContentSignature = '';
  let activeContentIndex = 0;
  let state = 'hidden';
  let scrollBound = false;
  let scrolling = false;
  let collapseTimer = 0;
  let contentRotateTimer = 0;
  let contentTransitionTimer = 0;
  let expandedAtScrollY = 0;
  let ignoreShowScrollThreshold = false;
  let stickyBarBase = null;
  let stickyBarMutationObserver = null;
  let stickyBarResizeObserver = null;
  let stickyBarUpdateRaf = 0;

  function ensureMount() {
    if (root) return root;
    root = document.createElement('div');
    root.className = 'dl-pop-minibar';
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML = [
      '<button type="button" class="dl-pop-minibar__content" aria-label="Open offer popup">',
      '  <span class="dl-pop-minibar__label" aria-hidden="true">',
      '    <span class="dl-pop-minibar__label-item"></span>',
      '    <span class="dl-pop-minibar__label-item"></span>',
      '    <span class="dl-pop-minibar__label-sizer"></span>',
      '  </span>',
      '  <span class="dl-pop-minibar__icon" aria-hidden="true">',
      '    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">',
      '      <path d="M7.50189 17.4843C8.75189 17.3349 9.16856 16.2368 10.0019 16.2368C10.8352 16.2368 11.2519 17.3349 12.5019 17.4843C13.7584 17.6338 15.0019 16.6526 15.0019 14.9892C15.0019 13.3259 13.3352 9.5832 10.0019 9.5832C6.66856 9.5832 5.00189 13.3259 5.00189 14.9892C5.00189 16.6526 6.24538 17.6338 7.50189 17.4843Z" fill="white"/>',
      '      <path d="M6.50717 8.14775C6.92037 9.28301 6.37885 10.5223 5.29765 10.9159C4.21644 11.3094 3.00499 10.7081 2.59178 9.57283C2.17858 8.43757 2.7201 7.19824 3.80131 6.80471C4.88251 6.41118 6.09397 7.01248 6.50717 8.14775Z" fill="white"/>',
      '      <path d="M9.51423 4.25232C9.84181 5.47485 9.2064 6.70731 8.09502 7.00511C6.98363 7.30291 5.81712 6.55326 5.48954 5.33074C5.16197 4.10821 5.79737 2.87575 6.90876 2.57795C8.02015 2.28015 9.18666 3.0298 9.51423 4.25232Z" fill="white"/>',
      '      <path d="M14.5142 5.33074C14.1867 6.55326 13.0201 7.30291 11.9088 7.00511C10.7974 6.70731 10.162 5.47485 10.4895 4.25232C10.8171 3.0298 11.9836 2.28015 13.095 2.57795C14.2064 2.87575 14.8418 4.10821 14.5142 5.33074Z" fill="white"/>',
      '      <path d="M17.4118 9.57285C16.9986 10.7081 15.7872 11.3094 14.706 10.9159C13.6248 10.5224 13.0832 9.28303 13.4964 8.14777C13.9096 7.01251 15.1211 6.41121 16.2023 6.80473C17.2835 7.19826 17.825 8.43759 17.4118 9.57285Z" fill="white"/>',
      '    </svg>',
      '  </span>',
      '</button>'
    ].join('');
    contentEl = root.querySelector('.dl-pop-minibar__content');
    root.labelEl = root.querySelector('.dl-pop-minibar__label');
    labelItems = [...root.querySelectorAll('.dl-pop-minibar__label-item')];
    labelSizer = root.querySelector('.dl-pop-minibar__label-sizer');
    contentEl.addEventListener('click', onContentClick);
    document.body.appendChild(root);
    ensureStickyBarTracking();
    return root;
  }

  function updateStickyBarOffset() {
    stickyBarUpdateRaf = 0;
    if (!root) return;

    const nextBase = document.querySelector('.dl-product-addtocart-v2-base');
    if (nextBase !== stickyBarBase) observeStickyBar(nextBase);

    if (!stickyBarBase?.classList.contains('dl-sticky-visible')) {
      root.style.setProperty('--dl-pop-minibar-sticky-offset', '0px');
      return;
    }

    // Layout height, not the live viewport overlap. The bar slides with
    // transform: translateY over 0.3s; reading rect.top mid-slide under-reports
    // and the minibar's own bottom transition would ease toward that short value.
    // The name/countdown strip is position:absolute above the bar and paints with
    // the bar itself. dl-info-visible flips later (variant title reaches the
    // viewport), so gating the extra height on that class lifts the minibar
    // after the sticky bar has already settled.
    let offset = stickyBarBase.offsetHeight;
    if (window.matchMedia('(max-width: 990px)').matches) {
      offset += paintedStripHeight(stickyBarBase.querySelector('.dl-product-addtocart-v2-info'));
      offset += paintedStripHeight(stickyBarBase.querySelector('.dl-product-addtocart-v2-countdown'));
    }
    root.style.setProperty('--dl-pop-minibar-sticky-offset', `${Math.max(0, Math.ceil(offset))}px`);
  }

  function paintedStripHeight(node) {
    if (!node) return 0;
    const style = window.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden') return 0;
    if (style.position !== 'absolute' && style.position !== 'fixed') return 0;
    if (Number.parseFloat(style.opacity || '0') <= 0) return 0;
    return node.offsetHeight || 0;
  }

  function scheduleStickyBarOffsetUpdate() {
    if (stickyBarUpdateRaf) cancelAnimationFrame(stickyBarUpdateRaf);
    stickyBarUpdateRaf = requestAnimationFrame(updateStickyBarOffset);
  }

  function observeStickyBar(base) {
    stickyBarMutationObserver?.disconnect();
    stickyBarResizeObserver?.disconnect();
    stickyBarBase = base;

    if (!stickyBarBase) {
      root?.style.setProperty('--dl-pop-minibar-sticky-offset', '0px');
      return;
    }

    stickyBarMutationObserver = new MutationObserver(scheduleStickyBarOffsetUpdate);
    stickyBarMutationObserver.observe(stickyBarBase, {
      attributes: true,
      attributeFilter: ['class']
    });

    if (typeof ResizeObserver === 'function') {
      stickyBarResizeObserver = new ResizeObserver(scheduleStickyBarOffsetUpdate);
      stickyBarResizeObserver.observe(stickyBarBase);
      const info = stickyBarBase.querySelector('.dl-product-addtocart-v2-info');
      if (info) stickyBarResizeObserver.observe(info);
    }
    scheduleStickyBarOffsetUpdate();
  }

  function ensureStickyBarTracking() {
    observeStickyBar(document.querySelector('.dl-product-addtocart-v2-base'));
    window.addEventListener('resize', () => {
      scheduleStickyBarOffsetUpdate();
      syncScrollVisibility();
    }, { passive: true });
  }

  function ensureScroll() {
    if (scrollBound) return;
    scrollBound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    const mediaQuery = window.matchMedia(COLLAPSE_MEDIA_QUERY);
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', onCollapseViewportChange);
    } else {
      mediaQuery.addListener(onCollapseViewportChange);
    }
  }

  function canCollapse() {
    return window.matchMedia(COLLAPSE_MEDIA_QUERY).matches;
  }

  function onCollapseViewportChange() {
    if (!canCollapse() && state === 'collapsed') setState('expanded');
  }

  function isMainContentShorterThanViewport() {
    const mainContent = document.getElementById('MainContent');
    if (!mainContent) return false;
    return mainContent.offsetHeight < window.innerHeight;
  }

  function isPastShowThreshold() {
    return ignoreShowScrollThreshold
      || isMainContentShorterThanViewport()
      || window.scrollY >= SHOW_SCROLL_DISTANCE;
  }

  function syncScrollVisibility() {
    if (!root) return false;
    const shouldShow = state !== 'hidden' && isPastShowThreshold();
    root.classList.toggle('dl-show', shouldShow);
    root.setAttribute('aria-hidden', String(!shouldShow));
    if (!shouldShow) clearCollapseTimer();
    return shouldShow;
  }

  function scheduleCollapse() {
    clearCollapseTimer();
    if (state !== 'expanded' || !canCollapse() || !root?.classList.contains('dl-show')) return;
    collapseTimer = setTimeout(() => setState('collapsed'), EXPANDED_DURATION);
  }

  function onScroll() {
    if (scrolling) return;
    scrolling = true;
    requestAnimationFrame(() => {
      const wasVisible = Boolean(root?.classList.contains('dl-show'));
      const isVisible = syncScrollVisibility();
      if (!wasVisible && isVisible && state === 'expanded') {
        expandedAtScrollY = window.scrollY;
        scheduleCollapse();
      } else if (isVisible && canCollapse() && state === 'expanded'
        && Math.abs(window.scrollY - expandedAtScrollY) >= COLLAPSE_SCROLL_DISTANCE) {
        setState('collapsed');
      }
      scrolling = false;
    });
  }

  function getEligible() {
    const list = [];
    sources.forEach((source) => {
      try {
        if (source && typeof source.canShow === 'function' && source.canShow()) {
          list.push(source);
        }
      } catch (_) { /* ignore broken source */ }
    });
    list.sort((a, b) => {
      const openedA = Number(a.getOpenedAt?.() || 0);
      const openedB = Number(b.getOpenedAt?.() || 0);
      if (openedB !== openedA) return openedB - openedA;
      return String(a.id).localeCompare(String(b.id));
    });
    return list;
  }

  function pickActive() {
    return getEligible()[0] || null;
  }

  function hasShowingPopup() {
    return Boolean(document.querySelector('.dl-pop-h-overlay.dl-show, dl-pop-raffle-y[data-showing="true"]'));
  }

  function clearCollapseTimer() {
    if (!collapseTimer) return;
    clearTimeout(collapseTimer);
    collapseTimer = 0;
  }

  function clearContentTimers() {
    if (contentRotateTimer) clearTimeout(contentRotateTimer);
    if (contentTransitionTimer) clearTimeout(contentTransitionTimer);
    contentRotateTimer = 0;
    contentTransitionTimer = 0;
  }

  function setLabelImmediately(text) {
    if (!root?.labelEl || labelItems.length < 2) return;
    root.labelEl.classList.add('is-resetting');
    root.labelEl.classList.remove('is-rotating');
    labelItems[0].textContent = text;
    labelItems[1].textContent = '';
    root.labelEl.offsetHeight;
    root.labelEl.classList.remove('is-resetting');
    contentEl.setAttribute('aria-label', text);
  }

  function updateLabelSizer(contents) {
    if (!labelSizer) return;
    labelSizer.replaceChildren(...contents.map((text) => {
      const item = document.createElement('span');
      item.textContent = text;
      return item;
    }));
  }

  function scheduleContentRotation() {
    if (contentRotateTimer) clearTimeout(contentRotateTimer);
    contentRotateTimer = 0;
    if (state === 'hidden' || activeContents.length < 2) return;
    contentRotateTimer = setTimeout(rotateContent, CONTENT_ROTATE_INTERVAL);
  }

  function rotateContent() {
    contentRotateTimer = 0;
    if (state === 'hidden' || activeContents.length < 2 || labelItems.length < 2) return;

    const sourceId = activeId;
    const nextIndex = (activeContentIndex + 1) % activeContents.length;
    const nextText = activeContents[nextIndex];
    labelItems[1].textContent = nextText;

    requestAnimationFrame(() => {
      if (state === 'hidden' || activeId !== sourceId) return;
      root.labelEl.classList.add('is-rotating');
      contentEl.setAttribute('aria-label', nextText);
      contentTransitionTimer = setTimeout(() => {
        contentTransitionTimer = 0;
        if (state === 'hidden' || activeId !== sourceId) return;
        activeContentIndex = nextIndex;
        setLabelImmediately(nextText);
        scheduleContentRotation();
      }, CONTENT_TRANSITION_DURATION);
    });
  }

  function setState(nextState) {
    ensureMount();
    scheduleStickyBarOffsetUpdate();
    clearCollapseTimer();
    const resolvedState = nextState === 'collapsed' && !canCollapse() ? 'expanded' : nextState;
    state = resolvedState;
    root.dataset.state = resolvedState;
    root.classList.toggle('is-expanded', resolvedState === 'expanded');
    root.classList.toggle('is-collapsed', resolvedState === 'collapsed');
    const isVisible = syncScrollVisibility();

    if (resolvedState === 'expanded' && isVisible) {
      expandedAtScrollY = window.scrollY;
      scheduleCollapse();
    }
    if (resolvedState === 'hidden') clearContentTimers();
    else scheduleContentRotation();
  }

  function getSourceContents(source) {
    let contents = [];
    try {
      const configuredContents = source?.getContents?.();
      if (Array.isArray(configuredContents)) {
        contents = configuredContents.map((item) => String(item || '').trim()).filter(Boolean);
      }
    } catch (_) { /* fall back to the fixed content */ }

    if (contents.length) return contents;
    const fallback = String(source?.getContent?.() || '').trim();
    return fallback ? [fallback] : [];
  }

  function renderSource(source) {
    ensureMount();
    const contents = getSourceContents(source);
    if (!source || !contents.length) return false;
    const sourceId = String(source.id);
    const signature = contents.join('\u0000');
    const sourceChanged = activeId !== sourceId || activeContentSignature !== signature;
    activeId = sourceId;
    activeContents = contents;
    activeContentSignature = signature;
    if (sourceChanged) {
      clearContentTimers();
      activeContentIndex = 0;
      updateLabelSizer(contents);
      setLabelImmediately(contents[0]);
    }
    root.dataset.activeId = source.id;
    return true;
  }

  function showSource(source, nextState) {
    if (hasShowingPopup() || !renderSource(source)) {
      hide();
      return false;
    }
    setState(nextState);
    return true;
  }

  function showExpanded(id) {
    let source = id ? sources.get(String(id)) : pickActive();
    if (!source || !getEligible().includes(source)) {
      source = pickActive();
    }
    if (!source) {
      hide();
      return false;
    }
    ignoreShowScrollThreshold = true;
    return showSource(source, 'expanded');
  }

  function showCollapsed(id) {
    const source = id ? sources.get(String(id)) : pickActive();
    if (!source || !getEligible().includes(source)) {
      hide();
      return false;
    }
    return showSource(source, 'collapsed');
  }

  function hide() {
    ignoreShowScrollThreshold = false;
    if (!root) return;
    setState('hidden');
    activeId = '';
    activeContents = [];
    activeContentSignature = '';
    activeContentIndex = 0;
    delete root.dataset.activeId;
  }

  function onContentClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const source = activeId ? sources.get(activeId) : pickActive();
    hide();
    if (source && typeof source.onOpen === 'function') source.onOpen();
  }

  function refresh() {
    ensureMount();
    ensureScroll();

    if (hasShowingPopup()) {
      hide();
      return;
    }

    const source = pickActive();
    if (!source) {
      hide();
      return;
    }

    if (state !== 'hidden' && activeId === source.id) {
      renderSource(source);
      return;
    }
    showSource(source, 'collapsed');
  }

  function register(source) {
    if (!source?.id) return;
    sources.set(String(source.id), source);
    ensureMount();
    ensureScroll();
    refresh();
  }

  function unregister(id) {
    sources.delete(String(id));
    if (activeId === String(id)) hide();
    refresh();
  }

  /** 弹窗主界面打开时隐藏 minibar */
  function hideWhilePopupShowing() {
    hide();
  }

  global.DLPopMiniBar = {
    __shared: true,
    register,
    unregister,
    refresh,
    requestShow: refresh,
    showExpanded,
    showCollapsed,
    hide,
    hideWhilePopupShowing,
    getActiveId: () => activeId,
    getState: () => state
  };
})(window);
